<template>
    <div class="my-2">
        <v-toolbar flat color="white">
            <v-spacer></v-spacer>
            <v-btn round color="primary" class="white--text" @click="addPackageTemplateCheck()">Add</v-btn>
        </v-toolbar>
        <v-data-table
        :headers="headers"
        class="elevation-1"
        disable-initial-sort
        :items="packagesIspTemplates"
        item-key="id"
        :key="key"
        align-center
        :rows-per-page-items="[25, 50, 100, 250]"
      >
        <template v-slot:items="props">
          <td class="text-xs-center">
            <v-layout justify-center>
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-icon
                    v-on="on"
                    medium
                    class="mr-1"
                    @click="editPackageTemplateItem(props.item)"
                  >edit</v-icon>
                </template>
                <span>Edit Package Template</span>
              </v-tooltip>
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-icon
                    v-on="on"
                    medium
                    class="mr-1"
                    @click="deletePackageTemplateItem(props.item)"
                  >delete</v-icon>
                </template>
                <span>Delete Package Template</span>
              </v-tooltip>
            </v-layout>
          </td>
          <td class="text-xs-center">{{props.item.speedProfile.name}}</td>
          <td class="text-xs-center">{{props.item.name}}</td>
          <td class="truncate">{{props.item.description}}</td>
          <td class="text-xs-center">{{props.item.recurringPrice|currency}}</td>
          <td class="text-xs-center">{{props.item.onceOffPrice|currency}}</td>
          <td class="text-xs-center" v-if="props.item.isFup">
            <v-icon color="green">done</v-icon>
          </td>
          <td class="text-xs-center" v-else>
            <v-icon color="red">not_interested</v-icon>
          </td>
          <td class="text-xs-center" v-if="props.item.isShaped">
            <v-icon color="green">done</v-icon>
          </td>
          <td class="text-xs-center" v-else>
            <v-icon color="red">not_interested</v-icon>
          </td>
          <td class="text-xs-center" v-if="props.item.isCapped">
            <v-icon color="green">done</v-icon>
          </td>
          <td class="text-xs-center" v-else>
            <v-icon color="red">not_interested</v-icon>
          </td>
          <td class="text-xs-center">{{props.item.cappedAmountGb}}</td>
          <td class="text-xs-center" v-if="props.item.isPromo">
            <v-icon color="green">done</v-icon>
          </td>
          <td class="text-xs-center" v-else>
            <v-icon color="red">not_interested</v-icon>
          </td>
          <td class="text-xs-center">{{props.item.promoDescription}}</td>
          <td class="text-xs-center">{{props.item.term}}</td>
        </template>
        <template
          v-slot:pageText="props"
        >Records {{ props.pageStart }} - {{ props.pageStop }} of {{ props.itemsLength }}</template>
      </v-data-table>
      <!-- Add Package Template Modal -->
    <v-dialog persistent v-model="addPackageTemplate" max-width="750px">
      <v-toolbar flat class="primary">
        <h1 class="headline white--text">{{item.modalType}} Template Package</h1>
        <v-spacer></v-spacer>
        <v-btn flat color="white" class="white--text" @click="addPackageTemplate=false, item={}">X</v-btn>
      </v-toolbar>
      <v-card flat color="white">
        <v-container grid-list-xs>
          <v-layout wrap>
            <v-flex xs12 sm6 md6>
              <v-autocomplete
                id="filterSpeedId"
                clearable
                v-model="item.speedProfileId"
                :items="speedProfiles"
                hide-no-data
                flat
                color="primary"
                label="*Speed"
                item-text="name"
                item-value="id"
              ></v-autocomplete>
            </v-flex>
            <v-flex xs12 sm6 md6>
              <v-text-field
                v-model="item.name"
                persistent-hint
                label="*Template Package Name"
              ></v-text-field>
            </v-flex>
            <v-flex xs12>
              <v-textarea
                v-model="item.description"
                persistent-hint
                label="Description"
              ></v-textarea>
            </v-flex>
            <v-flex xs12 sm6 md6>
              <v-text-field
                v-model="item.recurringPrice"
                persistent-hint
                label="*Recurring Price incl. VAT"
                type="number"
                step="0.01"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 md6>
              <v-text-field
                v-model="item.onceOffPrice"
                persistent-hint
                label="*Once Off Price incl. VAT"
                type="number"
                step="0.01"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 md6>
              <v-switch
                v-model="item.isFup"
                persistent-hint
                label="Fair Usage Policy"
              ></v-switch>
            </v-flex>
            <v-flex xs12 sm6 md6>
              <v-switch v-model="item.isShaped" persistent-hint label="Shaped"></v-switch>
            </v-flex>
            <v-flex xs12 sm6 md6>
              <v-switch v-model="item.isCapped" persistent-hint label="Capped"></v-switch>
            </v-flex>
            <v-flex xs12 sm6 md6 v-if="item.isCapped">
              <v-text-field
                type="number"
                v-model="item.cappedAmountGb"
                persistent-hint
                label="Capped Amount(Gb)"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 md6>
              <v-switch v-model="item.isPromo" persistent-hint label="Promotion"></v-switch>
            </v-flex>
            <v-flex xs12 sm6 md6 v-if="item.isPromo">
              <v-textarea
                v-model="item.promoDescription"
                persistent-hint
                label="Promotion Description"
              ></v-textarea>
            </v-flex>
            <v-flex xs12 sm6 md6>
              <v-autocomplete
                clearable
                hide-no-data
                flat
                color="primary"
                label="*Contract Term"
                :items="packageTerms"
                v-model="item.term"
              ></v-autocomplete>
            </v-flex>
             <v-flex xs12 sm6 md6>
              <v-checkbox
                color="primary"
                label="This package has specific T's & C's"
                v-model="item.hasSpecificTerms"
              ></v-checkbox>
             </v-flex>
               <v-flex xs12 v-if="item.hasSpecificTerms">
              <v-textarea
                color="primary"
                label="Please specify the specific terms & conditions"
                v-model="item.specificTerms"
              ></v-textarea>
            </v-flex>
          </v-layout>
        </v-container>
        <v-flex 12 xs12 sm12 md>
          <v-card-actions>
            <v-layout justify-center>
              <v-btn v-if="item.modalType=='Add'&&item.speedProfileId&&item.name&&(item.recurringPrice!=null&&item.recurringPrice!='')" color="primary" round @click="saveNewPackageTemplate()">Create Template</v-btn>
              <v-btn v-else-if="item.modalType=='Add'" round disabled>Create Template</v-btn>
              <v-btn v-else-if="item.modalType=='Edit'&&item.speedProfileId&&item.name&&(item.recurringPrice!==null&&item.recurringPrice!=='')" color="primary" round @click="updatePackageTemplate(item)">Save</v-btn>
              <v-btn v-else disabled round>Save</v-btn>
            </v-layout>
          </v-card-actions>
        </v-flex>
      </v-card>
    </v-dialog>
    </div>
</template>
<script>
import Api from '../services/Api'
export default {
    data(){
        return {
            addPackageTemplate: false,
            item: {},
            key: 0,
            speedProfiles: [],
            packageTerms: ["month-to-month", "6 month", "12 month", "24 month"],
            headers: [
        {
          text: "Action",
          align: "center",
          sortable: false
        },
        {
          text: "Speed Profile",
          align: "center",
          value: "speedProfile.name"
        },
        {
          text: "Template Name",
          align: "center",
          value: "name"
        },
        {
          text: "Description",
          align: "center",
          value: "description"
        },
        {
          text: "Recurring Price incl. VAT",
          align: "center",
          value: "recurringPrice"
        },
        {
          text: "Once Off Price incl. VAT",
          align: "center",
          value: "onceOffPrice"
        },
        {
          text: "FUP",
          align: "center",
          value: "isFup"
        },
        {
          text: "Shaped",
          align: "center",
          value: "isShaped"
        },
        {
          text: "Capped",
          align: "center",
          value: "isCapped"
        },
        {
          text: "Capped Amount (Gb)",
          align: "center",
          value: "cappedAmountGb"
        },
        {
          text: "Promotion",
          align: "center",
          value: "isPromo"
        },
        {
          text: "Promotion Description",
          align: "center",
          value: "promoDescription"
        },
        {
          text: "Term",
          align: "center",
          value: "term"
        }
      ],
            packagesIspTemplates: []
        }
    },
    created(){
        this.fetchPackageTemplates()
        this.fetchSpeedProfiles()
    },
    methods: {
        addPackageTemplateCheck() {
      if (this.authCreate(this.$store.state.currentRoute)) {
        // this.item.hasSpecificTerms = false
        this.item = {
            modalType:"Add",
            hasSpecificTerms: false,
            isFup: false,
            isShaped: false,
            isCapped: false,
            isPromo: false
        }
        this.addPackageTemplate = true;
      }
    },
        editPackageTemplateItem(item){
            if (this.authUpdate(this.$store.state.currentRoute)) {
                this.item = item
                this.item.modalType='Edit'
                this.addPackageTemplate = true
      }
        },
        deletePackageTemplateItem(item){
          if(this.authDelete(this.$store.state.currentRoute)){
            confirm("Are you sure you would like to delete this template?")&&
            Api().put('/customer/packagesIspTemplate/'+item.id, {isActive: false, isDeleted: true})
            .then(response=>{
                this.addPackageTemplate = false;
            this.item={}
            this.fetchPackageTemplates()
            })
          }
          
        },
        updatePackageTemplate(item){
            Api().put('/customer/packagesIspTemplate/'+item.id, item)
            .then(response=>{
                this.addPackageTemplate = false;
            this.item={}
            this.fetchPackageTemplates()
            })
        },
        fetchSpeedProfiles() {
      Api()
        .get("/speedProfiles/active")
        .then(response => {
          this.speedProfiles = response.data;
        });
    },
    async fetchPackageTemplates(){
      await Api()
      .get('/customer/packagesIspTemplate')
      .then(response=>{
        this.packagesIspTemplates=response.data
        this.key+=1
      })
    },
    saveNewPackageTemplate() {
      if (this.authCreate(this.$store.state.currentRoute)) {
        Api()
          .post("/packagesIspTemplate", {
            name: this.item.name,
            description: this.item.description,
            speedProfileId: this.item.speedProfileId,
            recurringPrice: this.item.recurringPrice,
            onceOffPrice: this.item.onceOffPrice?this.item.onceOffPrice:0,
            isFup: this.item.isFup,
            isShaped: this.item.isShaped,
            isPromo: this.item.isPromo,
            promoDescription: this.item.promoDescription,
            isCapped: this.item.isCapped,
            cappedAmountGb: this.item.cappedAmountGb,
            term: this.item.term,
            hasSpecificTerms: this.item.hasSpecificTerms,
            specificTerms: this.item.specificTerms,
            isActive: true,
            isDeleted: false
          })
          .then(response => {
            this.addPackageTemplate = false
            this.item = {}
            this.fetchPackageTemplates()
          });
      }
    },
    }
}
</script>